module.exports = __webpack_public_path__ + "media/images/shark/Naranjo_9252-1-aa5945188a087e728e999378fd88452b.jpg";